/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-07 11:53:30
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import {
  getTrainingRecordDetailAsync,
  getTrainingRecordSubmitAsync,
} from './TIManagementSlice'
import { getUserList } from '../../user/userSlice'
const { Option } = Select

export const AddOrEditFormDetailModal = (props: {
  isEdit?: any
  editTenantId?: any
  id?: any
  trainingId?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detail, setDetail] = useState<any>()

  const [userList, setUserList] = useState<any>()

  const [id, setId] = useState<any>()

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 17 },
  }

  const getDetail = () => {
    dispatch(
      getTrainingRecordDetailAsync({
        id: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        form.setFieldsValue({
          ...v,
          trainingObjectId: undefined,
          recordDate: v?.recordDate ? moment(v?.recordDate) : '',
        })

        dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
          .then(unwrapResult)
          .then((res: any) => {
            setUserList(res?.items)

            const trainingObjectId = res?.items?.find(
              (vs: any) => vs?.id == v?.trainingObjectId
            )

            form.setFieldsValue({
              trainingObjectId:
                trainingObjectId != undefined
                  ? v?.trainingObjectId?.toString()
                  : undefined,
            })
          })
      })
  }
  const getUserData = () => {
    dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
      .then(unwrapResult)
      .then((res: any) => {
        setUserList(res?.items)
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      } else {
        getUserData()
      }
    } else {
      form.resetFields()
      setUserList([])
      setId('')
    }
  }, [props.isModalVisible, props?.id])

  return (
    <>
      <Modal
        width={500}
        title={
          props?.isEdit == '0'
            ? '查看详情'
            : props?.id
            ? '编辑数据'
            : '添加数据'
        }
        visible={props.isModalVisible}
        footer={null}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            const trainingObject = userList?.find(
              (v: any) => v?.id == vs?.trainingObjectId
            )?.name

            setConfirmLoading(true)
            const params = props?.id
              ? {
                  ...detail,
                  ...vs,
                  id: detail?.id,
                }
              : {
                  ...vs,
                }
            dispatch(
              getTrainingRecordSubmitAsync({
                ...params,
                assessmentScore: Number(params?.assessmentScore),
                trainingObject: trainingObject,
                trainingId: props?.trainingId,
              })
            )
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: '操作成功',
                })
              })
              .finally(() => {
                props?.onOk()
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                {...layout}
                label='员工姓名'
                name='trainingObjectId'
                rules={[
                  {
                    required: true,
                    message: '员工姓名不能为空',
                  },
                ]}
              >
                <Select placeholder='员工姓名' allowClear>
                  {userList?.map((v: any, i: any) => {
                    return (
                      <Option value={v?.id} key={i}>
                        {v?.name}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                {...layout}
                label='考核得分'
                name='assessmentScore'
                rules={[
                  {
                    required: true,
                    message: '考核得分不能为空',
                  },
                ]}
              >
                <Input placeholder='考核得分' type='number' />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...layout} label='备注' name='remark'>
                <Input placeholder='备注' maxLength={50} />
              </Form.Item>
            </Col>
          </Row>
          {props?.isEdit == '0' ? (
            <></>
          ) : (
            <Row
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                loading={confirmLoading}
                type='primary'
                onClick={() => {
                  form.submit()
                }}
                style={{ marginRight: '10px' }}
              >
                确定
              </Button>
              <Button
                type='primary'
                ghost
                style={{ marginRight: '10px' }}
                onClick={() => {
                  props?.onCancel()
                }}
              >
                取消
              </Button>
            </Row>
          )}
        </Form>
      </Modal>
    </>
  )
}
